import { LoadingSpinner } from "@newsela/angelou";

import BaseLayout from "@/base";
import RootProviders from "@/base/RootProviders";
import ErrorMessage from "@/errors/ErrorMessage";
import NotLoggedInError from "@/errors/NotLoggedInError";
import { useGetUser } from "@/users/v3";
import useUserFeaturesQuery from "@/users/v3/useUserFeaturesQuery";

import BundlePage from "@/bundles/BundlePage";

import type { NextPageContext } from "next";

const BundlePageRoute = () => {
  const { data: user, isLoading: isLoadingUser, isError } = useGetUser();

  const { data: features, isLoading: isUserFeaturesLoading } =
    useUserFeaturesQuery();
  const activeStemLicense = features?.includes("has_stem_license");

  if (isUserFeaturesLoading || isLoadingUser) {
    return <BaseLayout mainContents={<LoadingSpinner />} />;
  }

  if (!activeStemLicense || isError) {
    return (
      <BaseLayout
        mainContents={
          <ErrorMessage headline="Oh no! Something went wrong.">
            <p>Either you do not have access, or an error has occurred.</p>
          </ErrorMessage>
        }
      />
    );
  }

  if (!user?.is_authenticated) {
    return <BaseLayout mainContents={<NotLoggedInError />} />;
  }

  return <BaseLayout mainContents={<BundlePage />} />;
};

export const getServerSideProps = async (ctx: NextPageContext) => {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
};

export default BundlePageRoute;
